import Repository from "@/services/repository";

export default {
  searchPages(studyId, text) {
    return Repository.get(`/a/${studyId}/google_results_page/search.json`, {
      params: {
        searchQuery: text,
      },
    }).then((response) => response.data);
  },
};
